import { render, staticRenderFns } from "./WorkStatusList.vue?vue&type=template&id=38f36fa4"
import script from "./WorkStatusList.vue?vue&type=script&lang=js"
export * from "./WorkStatusList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports